import type { OperatorDto, OperatorInputDto, PagedRequestOperatorDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class OperatorService {
  apiName = 'Default';
  

  createOperatorByInput = (input: OperatorInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/operator/operator',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  editOperatorByInput = (input: OperatorInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/operator/edit-operator',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getAllOperatorsByInput = (input: PagedRequestOperatorDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OperatorDto>>({
      method: 'GET',
      url: '/api/app/operator/operators',
      params: { textFilter: input.textFilter, state: input.state, areaId: input.areaId, subAreaId: input.subAreaId, shiftId: input.shiftId, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getOperatorByOperatorId = (operatorId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OperatorDto>({
      method: 'GET',
      url: `/api/app/operator/operator/${operatorId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
